/**
 * Metabolics — Multibuy Tier Inject
 * ──────────────────────────────────
 * 1. Adds "SAVE UP TO X%" badge to the OTP option
 * 2. Clickable tier buttons that set the quantity
 * 3. Fixes practitioner frequency tab percentages
 *
 * CONFIG: Edit MULTIBUY_CONFIG to add/remove products.
 *
 * SETUP — in main-product.liquid:
 *   <script>window.__mbProductId = {{ product.id }};</script>
 *   <script src="{{ 'multibuy-inject.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════════
     MULTIBUY CONFIG — edit this to manage offers
     Key = Shopify product ID
     ══════════════════════════════════════════════════ */

  var MULTIBUY_CONFIG = {
    // Magnesium Bisglycinate Capsules
    8990896062796: {
      display_name: 'BUY MORE SAVE MORE',
      purchase_type: 'onetime',
      tiers: [
        { qty: 2, discount_pct: 5 },
        { qty: 3, discount_pct: 8 }
      ]
    }
    // Add more products:
    // 1234567890123: { ... }
  };

  /* ── Resolve product ───────────────────────── */

  var productId = window.__mbProductId
    || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product
        && window.ShopifyAnalytics.meta.product.id)
    || null;

  if (!productId) return;
  var data = MULTIBUY_CONFIG[productId];
  if (!data || !data.tiers || !data.tiers.length) return;

  /* Practitioners get their own discount — skip multibuy but still fix freq tabs */
  var mbSub = window.__mbSub || {};
  var IS_PRACTITIONER = !!mbSub.isPractitioner;

  var TIERS = data.tiers;
  var maxPct = Math.max.apply(null, TIERS.map(function (t) { return t.discount_pct; }));

  /* ── CSS ────────────────────────────────────── */

  function injectStyles() {
    if (document.getElementById('mb-multibuy-css')) return;
    var s = document.createElement('style');
    s.id = 'mb-multibuy-css';
    s.textContent = [
      /* Badge — top-right of OTP */
      '.mb-otp-badge{position:absolute;top:-1px;right:-1px;background:#1E2A3A;color:#fff;font-size:11px;font-weight:700;padding:4px 12px;border-radius:0 12px 0 12px;letter-spacing:0.33px;text-transform:uppercase;white-space:nowrap;z-index:2;line-height:normal}',
      '.smarte-sub-otp{position:relative !important}',

      /* Tier container */
      '.mb-tiers{margin-top:8px;padding-top:8px;border-top:1px solid #e8e5e0}',

      /* Clickable tier buttons — side by side */
      '.mb-tiers__btns{display:flex;gap:6px}',
      '.mb-tiers__btn{flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:9px 8px;border-radius:8px;border:1.33px solid #D0C8BF;background:#fff;cursor:pointer;transition:all .2s;text-align:center}',
      '.mb-tiers__btn:hover{border-color:#1E2A3A;background:#f8f7f5}',
      '.mb-tiers__btn-qty{font-size:12px;font-weight:600;color:#1E2A3A}',
      '.mb-tiers__btn-pct{font-size:12px;font-weight:700;color:#1E2A3A}',
      '.mb-tiers__btn-check{display:none;width:14px;height:14px;border-radius:50%;background:#1E2A3A;color:#fff;font-size:8px;align-items:center;justify-content:center;flex-shrink:0}',

      /* Active tier */
      '.mb-tiers__btn.is-active{border-color:#1E2A3A;background:#1E2A3A;color:#fff}',
      '.mb-tiers__btn.is-active .mb-tiers__btn-qty{color:#fff}',
      '.mb-tiers__btn.is-active .mb-tiers__btn-pct{color:#fff}',
      '.mb-tiers__btn.is-active .mb-tiers__btn-check{display:inline-flex}',

      /* Note */
      '.mb-tiers__note{font-size:10px;color:#999;margin-top:6px}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ── Build tier buttons ────────────────────── */

  function buildTiersHTML() {
    var btns = '';
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i];
      btns += '<button type="button" class="mb-tiers__btn" data-mb-tier data-tier-qty="' + t.qty + '" data-tier-pct="' + t.discount_pct + '">'
        + '<span class="mb-tiers__btn-qty">Buy ' + t.qty + '+</span>'
        + '<span class="mb-tiers__btn-pct">Save ' + t.discount_pct + '%</span>'
        + '<span class="mb-tiers__btn-check" aria-hidden="true">✓</span>'
        + '</button>';
    }
    return '<div class="mb-tiers" id="mb-tiers-inject">'
      + '<div class="mb-tiers__btns">' + btns + '</div>'
      + '<div class="mb-tiers__note">Applied at checkout · One-time purchases only</div>'
      + '</div>';
  }

  /* ── Set quantity across all inputs ────────── */

  function setQuantity(qty) {
    // Find the product form
    var form = document.querySelector('form[action="/cart/add"]')
      || document.querySelector('form[id*="product-form"]')
      || document.querySelector('product-form form');

    if (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        // No quantity input in form — create a hidden one
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        form.appendChild(qtyInput);
      }
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Also sync any visible quantity inputs (if quantity_selector block is enabled)
    var visible = document.querySelectorAll('[id^="Quantity-"]');
    visible.forEach(function (inp) {
      inp.value = qty;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });

    updateHighlight(qty);
  }

  /* ── Tier highlighting + price update ────────── */

  var originalPrice = null; // captured on first run

  function updateHighlight(qty) {
    var btns = document.querySelectorAll('#mb-tiers-inject [data-mb-tier]');
    if (!btns.length) return;

    // Capture original OTP price once
    var priceEl = document.querySelector('.smarte-sub-otp-price');
    if (priceEl && originalPrice === null) {
      var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
      originalPrice = parseFloat(priceText) || null;
    }

    // Determine active tier
    var activeIdx = -1;
    var activePct = 0;
    for (var i = btns.length - 1; i >= 0; i--) {
      if (qty >= parseInt(btns[i].dataset.tierQty)) {
        activeIdx = i;
        activePct = parseInt(btns[i].dataset.tierPct) || 0;
        break;
      }
    }
    for (var j = 0; j < btns.length; j++) {
      btns[j].classList.toggle('is-active', j === activeIdx);
    }

    // Update OTP price display
    if (priceEl && originalPrice) {
      if (activePct > 0) {
        var discounted = (originalPrice * (1 - activePct / 100)).toFixed(2);
        priceEl.innerHTML = '<s style="color:#999;font-weight:400;font-size:0.85em;margin-right:4px">£' + originalPrice.toFixed(2) + '</s>£' + discounted;
      } else {
        priceEl.textContent = '£' + originalPrice.toFixed(2);
      }
    }
  }

  /* ── Bind tier button clicks ───────────────── */

  function bindTierButtons() {
    var btns = document.querySelectorAll('#mb-tiers-inject [data-mb-tier]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.dataset.tierQty) || 1;
        setQuantity(qty);
      });
    });
  }

  /* ── Listen to external qty changes ────────── */

  function listenToQty() {
    var inputs = document.querySelectorAll('input[name="quantity"], [id^="Quantity-"]');
    inputs.forEach(function (q) {
      updateHighlight(parseInt(q.value) || 1);
      q.addEventListener('change', function () { updateHighlight(parseInt(q.value) || 1); });
      q.addEventListener('input', function () { updateHighlight(parseInt(q.value) || 1); });
      var wrap = q.closest('quantity-input');
      if (wrap) {
        wrap.querySelectorAll('button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            setTimeout(function () { updateHighlight(parseInt(q.value) || 1); }, 50);
          });
        });
        new MutationObserver(function () {
          updateHighlight(parseInt(q.value) || 1);
        }).observe(q, { attributes: true, attributeFilter: ['value'] });
      }
    });
  }

  /* ── Inject into Smarte Sub OTP ────────────── */

  function injectTiers() {
    var otpBox = document.querySelector('.smarte-sub-otp');
    if (!otpBox) return false;
    if (otpBox.querySelector('.mb-otp-badge')) return true;

    // Badge — top-right
    var badge = document.createElement('span');
    badge.className = 'mb-otp-badge';
    badge.textContent = 'SAVE UP TO ' + maxPct + '%';
    otpBox.style.position = 'relative';
    otpBox.appendChild(badge);

    // Tier buttons
    var w = document.createElement('div');
    w.innerHTML = buildTiersHTML();
    otpBox.appendChild(w.firstElementChild);

    // Bind clicks + listen for external qty changes
    bindTierButtons();
    listenToQty();

    return true;
  }

  /* ── Practitioner: fix frequency tab percentages ── */

  function fixFrequencyTabs() {
    var cfg = window.__mbSub || {};
    if (!cfg.isPractitioner) return true;

    var subPct = cfg.practitionerSubPct || 30;
    var otpPct = cfg.practitionerOtpPct || 25;
    var pills = document.querySelectorAll('.smarte-sub-pill-save');
    if (!pills.length) return false;

    pills.forEach(function (el) {
      // Determine if this pill is inside the OTP or S&S section
      var isOtp = !!el.closest('.smarte-sub-otp');
      var pct = isOtp ? otpPct : subPct;
      var expected = 'save ' + pct + '%';
      if (el.textContent.trim().toLowerCase() !== expected) {
        el.textContent = 'save ' + pct + '%';
      }
    });
    return pills.length > 0;
  }
  /* ── Practitioner: OTP savings badge ────────── */

  function injectPractitionerOtpBadge() {
    var otpBox = document.querySelector('.smarte-sub-otp');
    if (!otpBox) return false;
    if (otpBox.querySelector('.mb-otp-badge')) return true;

    var otpPct = (window.__mbSub || {}).practitionerOtpPct || 25;
    var badge = document.createElement('span');
    badge.className = 'mb-otp-badge';
    badge.textContent = 'SAVE ' + otpPct + '%';
    otpBox.style.position = 'relative';
    otpBox.appendChild(badge);

    // Hide the inline "save 25%" text next to the price (now redundant)
    var inlineSave = otpBox.querySelector('.smarte-sub-pill-save, .smarte-sub-otp-save');
    if (inlineSave) inlineSave.style.display = 'none';

    return true;
  }

  /* ── Init ───────────────────────────────────── */

  injectStyles();

  function tryInject() {
    var tiersOk = IS_PRACTITIONER ? injectPractitionerOtpBadge() : injectTiers();
    var freqOk = fixFrequencyTabs();
    return tiersOk && freqOk;
  }

  if (tryInject()) return;

  var n = 0;
  var poll = setInterval(function () { n++; if (tryInject() || n > 80) clearInterval(poll); }, 250);
  var mo = new MutationObserver(function () { if (tryInject()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });

})();
